module.exports = __webpack_public_path__ + "img/main_peogeot.18c3c84f.png";